import { Box } from "@mui/material";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import React, { useEffect } from "react";

const Map = ({
  lat,
  long,
  setLat,
  setLong,
}: {
  lat?: number;
  long?: number;
  setLat?: (lat: number) => void;
  setLong?: (lat: number) => void;
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  });

  const center = { lat: lat || 10.776888, lng: long || 106.700897 }; // Vị trí mặc định của bản đồ
  useEffect(() => {
    if (lat && long) setMarkerPosition({ lat: lat, lng: long });
  }, [lat, long]);
  const [markerPosition, setMarkerPosition] = React.useState(center);
  useEffect(() => {
    setLat && setLat(markerPosition.lat);
    setLong && setLong(markerPosition.lng);
  }, [JSON.stringify(markerPosition)]);

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    // Lấy vị trí khi người dùng click vào bản đồ
    const { latLng } = event;
    const lat = latLng?.lat() || 0;
    const lng = latLng?.lng() || 0;
    if (setLat && setLong) {
      setMarkerPosition({ lat, lng });
    }
  };
  if (!isLoaded) {
    return <></>;
  }

  return (
    <Box>
      <GoogleMap
        id="map"
        mapContainerStyle={{ width: "100%", height: "500px", borderRadius: "10px" }}
        zoom={15}
        center={center}
        onClick={handleMapClick}
      >
        {markerPosition.lat && (
          <Marker
            position={
              markerPosition || {
                lat: lat || 10.776888,
                lng: long || 106.700897,
              }
            }
            draggable={true}
            onDragEnd={handleMapClick}
          />
        )}
      </GoogleMap>
    </Box>
  );
};

export default Map;
